import React from "react";
import { nowISO } from "../../utils";
import { makeStyles } from "tss-react/mui";
import { Typography } from "@mui/material";
import { SectionCard } from "../study/course/SectionCard";
import Button from "../Button";
import { useStudy } from "../../pages/study/hooks";
import { addAssignmentActivitiesByCourseAndAssignee } from "../../store/study/studyBaseApi";
import CompleteChapterButton from "./CompleteChapterButton";
import { useCourse } from "../../pages/course/hooks";

const useStyles = makeStyles()((theme) => ({
    actionBtn: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        justifyContent: "center",
        display: "flex"
    },
}));

export default function StoryWithKeywords({ data, courseId, sectionId, onComplete, onNextChapter }) {
    const { classes } = useStyles();
    const { profile } = useStudy();
    const { lastSectionChapter } = useCourse();
    const [chapter, setChapter] = React.useState({});
    const [completed, setCompleted] = React.useState(false);
    const startTime = React.useRef(nowISO());

    const handleComplete = async () => {
        if (onComplete && typeof onComplete === "function") {
            onComplete();
        }

        setCompleted(true);

        try {
            await addAssignmentActivitiesByCourseAndAssignee({
                params: { courseId, assigneeId: profile.id }, body: {
                    assigneeId: profile.id, courseId, sectionId,
                    chapterId: chapter.chapterId,
                    endTime: nowISO(),
                    startTime: startTime.current,
                    type: 'CHAPTER_COMPLETE',
                }
            });
            if (!lastSectionChapter.chapter) {
                await onNextChapter();
            }
        } catch (e) {
            console.error(e);
        }
    }

    React.useEffect(() => {
        setChapter(data);
    }, [data]);

    if (!Object.keys(chapter).length) return <></>;

    return (
        <React.Fragment>
            <Typography color="primary.questionHead" variant="h4" sx={{ mb: 2, fontWeight: '600' }}>
                Activity
            </Typography>
            <div className={classes.actionBtn}>
                {!completed && <CompleteChapterButton onClick={handleComplete} />}
            </div>
        </React.Fragment>
    )
}